/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_StopInputs */

const th_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หยุดถ่ายทอดสด`)
};

const en_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop broadcasting`)
};

const ja_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配信を停止`)
};

const zh_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停止直播`)
};

const es_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar de retransmitir`)
};

const pt_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar de transmitir`)
};

const id_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hentikan siaran`)
};

const fr_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter la diffusion`)
};

const tl_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itigil ang sahimpapawid`)
};

const vi_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dừng phát`)
};

const ko_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중계 중지`)
};

const de_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übertragung beenden`)
};

const ru_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Остановить трансляцию`)
};

const tr_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayını durdur`)
};

const it_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrompi la trasmissione`)
};

const pl_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatrzymaj transmisję`)
};

const uk_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зупинити трансляцію`)
};

const hi_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रसारण रोकें`)
};

const ar_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إيقاف البث`)
};

const ms_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hentikan siaran`)
};

const bn_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্প্রচার থামান`)
};

const zh_tw2_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停止轉播`)
};

const zh_hk2_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停止轉播`)
};

const ur_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشریات روکیں`)
};

const fa_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توقف پخش`)
};

const sw_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simamisha urushaji`)
};

const nl_video_stop = /** @type {(inputs: Video_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitzending stoppen`)
};

/**
* | output |
* | --- |
* | "Stop broadcasting" |
*
* @param {Video_StopInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_stop = /** @type {((inputs?: Video_StopInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_StopInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_stop(inputs)
	if (locale === "ja") return ja_video_stop(inputs)
	if (locale === "zh") return zh_video_stop(inputs)
	if (locale === "es") return es_video_stop(inputs)
	if (locale === "pt") return pt_video_stop(inputs)
	if (locale === "id") return id_video_stop(inputs)
	if (locale === "fr") return fr_video_stop(inputs)
	if (locale === "tl") return tl_video_stop(inputs)
	if (locale === "vi") return vi_video_stop(inputs)
	if (locale === "ko") return ko_video_stop(inputs)
	if (locale === "de") return de_video_stop(inputs)
	if (locale === "ru") return ru_video_stop(inputs)
	if (locale === "tr") return tr_video_stop(inputs)
	if (locale === "it") return it_video_stop(inputs)
	if (locale === "pl") return pl_video_stop(inputs)
	if (locale === "uk") return uk_video_stop(inputs)
	if (locale === "hi") return hi_video_stop(inputs)
	if (locale === "ar") return ar_video_stop(inputs)
	if (locale === "ms") return ms_video_stop(inputs)
	if (locale === "bn") return bn_video_stop(inputs)
	if (locale === "zh-TW") return zh_tw2_video_stop(inputs)
	if (locale === "zh-HK") return zh_hk2_video_stop(inputs)
	if (locale === "ur") return ur_video_stop(inputs)
	if (locale === "fa") return fa_video_stop(inputs)
	if (locale === "sw") return sw_video_stop(inputs)
	if (locale === "nl") return nl_video_stop(inputs)
	return en_video_stop(inputs)
});